import { RichTextContent } from './richtext'

export type AccountDrawerMempershipPerk = {
  label?: string
  backgroundColor?: string
  iconUrl?: string
}

export type AccountDrawerMarketingImage = {
  link?: string
  imageUrl?: string
}

export type AccountDrawerShortcut = {
  label?: string
  link?: string
  backgroundColor?: string
  iconUrl?: string
}

export type AccountDrawerConfiguration = {
  signUpButtonLabel?: string
  membershipPerksTitle?: string
  membershipPerks?: AccountDrawerMempershipPerk[]
  marketingImagesLocation?: AccountDrawerMarketingImagesLocation
  marketingImages?: AccountDrawerMarketingImage[]
  accountShortcuts?: AccountDrawerShortcut[]
  helpCentreMessage?: {
    json?: RichTextContent
  }
}

export enum AccountDrawerMarketingImagesLocation {
  Bottom = 'bottom',
  Middle = 'middle',
  Top = 'top',
}
